import { status } from 'skin/event/status';
import cell from './cell';

const row = (obj, form, story, data, d, action) => {
	switch (obj.table) {
		case 'cmpRewList':
			return cell(obj, form, story, data, d, action);
		default:
	}
	return status.action;
};

export default row;
